/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VmAgentsQueryQualysStatus extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("VmAgentsQueryQualysStatus");
    }

    getFixupPrototypeFunction() { return VmAgentsQueryQualysStatus.fixupPrototype; }

    static newInstance(model: Partial<VmAgentsQueryQualysStatus>): VmAgentsQueryQualysStatus {
        let obj = Object.assign(new VmAgentsQueryQualysStatus(), model);
        VmAgentsQueryQualysStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VmAgentsQueryQualysStatus>): VmAgentsQueryQualysStatus {
        if (!model) return null;
        return VmAgentsQueryQualysStatus.newInstance(<VmAgentsQueryQualysStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VmAgentsQueryQualysStatus) {
        if (!obj) return;

        models.VmAgentsQueryQualysStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VmAgentsQueryQualysStatus): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VmAgentsQueryQualysStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Qualys Installation Status
     */
    qualys_status: Array<models.InstallationStatus>;

}
